import React from 'react';
import TransactionItem from '../TransactionItem/TransactionItem';
import './TransactionList.css';
import { useTranslation } from 'react-i18next';

const TransactionList = ({ transactions = [] }) => {
  const { t } = useTranslation("history");
  
  if (transactions.length === 0) {
    return (
      <div className="transaction-list empty">
        <div className="empty-state">
          <span className="empty-icon">📝</span>
          <h3>{t("HISTORY_IS_EMPTY")}</h3>
          <p>{t("YOUR_TRANSACTIONS")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="transaction-list">
      {transactions.map((transaction) => (
        <TransactionItem 
          key={transaction.created_at} 
          transaction={transaction} 
        />
      ))}
    </div>
  );
};

export default TransactionList;